module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Second Go-Round")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("By Andrew Grey")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Former world champion bronco rider Dustin and rancher Marshall have been life partners for more than twenty years, and time has taken its toll. Their sex life is as dusty as the rodeo ring. Somehow their marriage hasn’t turned out how they planned.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But when a new family moves in up the road with two young boys, one very sick, Dustin and Marshall realize how deep their ruts are and that there might be hope to break them. After all, where they’re from, the most important part of being a man is helping those who need it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A new common purpose helps break down the deep routines they’ve fallen into and makes them realize the life they’ve been living has left them both cold and hollow. Spending time with the kids—teaching them how to be cowboys—reignites something they thought lost long ago. But twenty years is a lot of time to make up for. Can they find their way back to each other, or are the ruts they’ve created worn too deep?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b970d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0